import { render, staticRenderFns } from "./ContractsEditor.vue?vue&type=template&id=1fd66b5e&"
import script from "./ContractsEditor.vue?vue&type=script&lang=js&"
export * from "./ContractsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports